import { useCurrentCriteriaIndex } from '../useCurrentCriteriaIndex';

export const useCriteriaFieldPath = () => {
  const index = useCurrentCriteriaIndex();
  return `query.searchQueries.${index}` as const;
};
